import { Box } from '@hivebrite/design-system/Box';
import type { EmbedType } from '@hivebrite/design-system/Embed';
import { Loader } from '@hivebrite/design-system/Loader';
import { useEmbedLy } from '@hivebrite/react-hooks';

import VideoNewUI from 'hb-builder/components/UIComponents/page/single/Video/components/VideoNewUI';
import { useSectionContext } from 'hb-builder/hooks';
import { VIDEO_TYPE_ATTRIBUTE } from 'hb-react/backoffice/types/builder/itemAttributes/videoItemAttributes';
import Embed from 'hb-react/shared/components/DesignSystem/Embed';

const VideoUI = ({ isDisabled, type, url, videoImageSrc }) => {
  const { nbFinalChildren } = useSectionContext();
  const isSectionFullWidth = nbFinalChildren === 1;

  const { response, isLoading } = useEmbedLy(url, {
    apiUrl: `${window.location.origin}${Routes.embed_path()}`,
  });

  const embed = response as EmbedType;

  if (!response && (type === VIDEO_TYPE_ATTRIBUTE.LINK || !type)) {
    return (
      <Box justifyContent="center" height={100} width="100%">
        {isLoading ? <Loader size={32} /> : <div />}
      </Box>
    );
  }

  if (videoImageSrc || type !== VIDEO_TYPE_ATTRIBUTE.LINK) {
    return (
      <VideoNewUI
        isDisabled={isDisabled}
        type={type}
        url={url}
        videoImageSrc={videoImageSrc}
        embed={embed}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Embed
      autoplay
      embed={embed}
      mediaAspectRatio={isSectionFullWidth ? undefined : 1.777778}
      withDescription={false}
      isDisabled={isDisabled}
      isLoading={isLoading}
      roundCorners="none"
    />
  );
};

export default VideoUI;
